import { ClientContractState } from "../store/client_contract_state";
import { Reducer } from "redux";
import {
  ClientContractAction,
  ClientContractActionType,
  ICallbackCreateContractAction,
  ICallbackOpenCreateFormContractAction,
  ICallbackUpdateContractAction,
  ICallbackApproveContractAction,
} from "../action/client_contract_action";

const initialState: ClientContractState = {
  project: null,
  customer: null,
  contract: null,
  isLoading: false,
};

const clientContractReducer: Reducer<ClientContractState> = (
  state = initialState,
  action: ClientContractAction
): ClientContractState => {
  switch (action.type) {
    case ClientContractActionType.REQUEST_CREATE_CONTRACT: {
      return Object.assign({}, state, {
        project: state.project,
        customer: state.customer,
        contract: state.contract,
        isLoading: true,
      });
    }
    case ClientContractActionType.CALLBACK_CREATE_CONTRACT: {
      const _action = action as ICallbackCreateContractAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          contract: _action.item ? _action.item.contract : null,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    case ClientContractActionType.REQUEST_UPDATE_CONTRACT: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientContractActionType.CALLBACK_UPDATE_CONTRACT: {
      const _action = action as ICallbackUpdateContractAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          contract: _action.item ? _action.item.contract : null,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    case ClientContractActionType.REQUEST_OPENCREATEFORM_CONTRACT: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientContractActionType.CALLBACK_OPENCREATEFORM_CONTRACT: {
      const _action = action as ICallbackOpenCreateFormContractAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          project: _action.item ? _action.item.project : null,
          customer: _action.item ? _action.item.customer : null,
          contract: _action.item ? _action.item.contract : null,
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    case ClientContractActionType.REQUEST_APPROVE_CONTRACT: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientContractActionType.CALLBACK_APPROVE_CONTRACT: {
      const _action = action as ICallbackApproveContractAction;
      if (_action.isSuccess) {
        return Object.assign({}, state, {
          isLoading: false,
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    default:
      return state;
  }
};

export default clientContractReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_contract_reducer.ts